module.exports = __webpack_public_path__ + "static/media/gibraltar_panorama2.8c426ccb.jpg";